import Vue from 'vue'
import FilesTransformer from '@/transformers/extranet/FilesTransformer'

/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

const fetchFiles = affectedId =>
  Vue.$http.get(`catalogs/common/file/visible-to-customers/${affectedId}/`)
    .then(response => FilesTransformer.fetchCollection(response.data))
    .catch((error) => { throw error })

export default fetchFiles


// WEBPACK FOOTER //
// ./src/services/extranet/fetchFiles.js